import React from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Alert from '@mui/material/Alert';
import { useMutation, useQueryClient } from 'react-query';
import AddValidationComment from '../../Ats/SuperAdminInbox/AddValidationComment';
import EditValidationComment from '../../Ats/SuperAdminInbox/EditValidationComment';

const ShowValidationMessages = (props) => {
  const [isHideAll, setIsHideAll] = React.useState(false);
  const queryClient = useQueryClient()

  const dataProvider = useDataProvider();
  const notify = useNotify();
  const canAddValidationMessages =
    props?.canAddValidationMessages === undefined
      ? true
      : props?.canAddValidationMessages;

  React.useEffect(() => {
    const isAllDeleted = props?.validation_message?.every(
      (message) => message?.isDeleted
    );
    setIsHideAll(isAllDeleted);
  }, [props?.validation_message]);


  const { mutate, isLoading, isSuccess } = useMutation(props.tag, (data: any) => dataProvider.disableValidationMessage({
    id: data.id,
    isDeleted: data.isDeleted,
  }),
    {
      onSuccess: (data) => {

        queryClient.invalidateQueries([`${props.invalidateQueries}`])
        notify("Validation message status updated", { type: "success", anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      },
      onError: (data) => {
        alert("error")
      },
      onMutate: () => {
        notify('Updating status...', { type: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
      }
    })

  const { mutate: mutateHandleHideAll, isLoading: isLoadingHideAll, isSuccess: isSuccessHideAll } = useMutation(`updateAllValidationMessages_${props.tag}`, (data: any) => {
    let promises: any = [];
    props?.validation_message?.map(
      async (message) =>
        promises.push(
          dataProvider.disableValidationMessage({
            id: message?.ID,
            isDeleted: data.isDeleted,
          }))
    );
    return Promise.all(promises)
  },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries([`${props.invalidateQueries}`])
        notify("Validation message status updated", { type: "success", anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      },
      onError: (data) => {
        alert("error")
      },
      onMutate: () => {
        notify('Updating status...', { type: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
      }
    })


  const showOrHideValidationMessage = async (id, isDeleted) => {
    mutate({
      id: id,
      isDeleted: isDeleted,
    })
  };

  const handleHideAll = async (val) => {
    setIsHideAll(!val);
    mutateHandleHideAll({
      isDeleted: val
    })
  };
  const validationMessageList: any[] = props?.validation_message ?? [];

  // Function for set a flag value
  const hasAnyNotificationOne = (objects) => {
    return objects
      ? objects?.some(
        (notification) => notification?.message && notification?.message !== ""
      )
      : false;
  };
  const hasRenderableMessages = hasAnyNotificationOne(validationMessageList);
  const sectionTitle = !props?.isApplicantTitle
    ? "Subscriber Validation"
    : "Applicant Validation";
  return (
    <div className={`notify-wrap mt-2 mb-1`}>
      <div className="notify-head" style={{ marginBottom: 0 }}>
        <h4 style={{ fontSize: 12 }}>{sectionTitle} </h4>
        {props?.role === "Docuverus Super Admin" && (
          <div>
            {validationMessageList.length > 0 && (
              <Button
                className="print-hide"
                startIcon={isHideAll ? <VisibilityIcon /> : <VisibilityOffIcon />}
                onClick={() => handleHideAll(isHideAll ? false : true)}
              >
                {isHideAll ? "Unhide All" : "Hide All"}
              </Button>
            )}
            {canAddValidationMessages && <AddValidationComment {...props} />}
          </div>
        )}
      </div>
      {hasRenderableMessages ? (
        validationMessageList.map((notification, index) => {
          if (!(notification?.message && notification?.message !== "")) {
            return null;
          }
          return (
            <Alert
              severity="warning"
              key={notification?.message + index}
              className={notification.isDeleted ? 'print-hide' : ''}
              sx={{
                '& .MuiAlert-icon': {
                  fontSize: 15,
                  marginTop: '3px',
                },
                '& .MuiAlert-action': {
                  alignItems: 'center',
                  columnGap: '2px',
                  marginRight: 0,
                  padding: '0 0 0 8px',
                },
                fontSize: 11,
                textDecoration: notification.isDeleted ? 'line-through' : 'none',
                paddingTop: 0,
                paddingBottom: 0
              }}
              action={props.role === "Docuverus Super Admin" ? (
                notification.isDeleted ? (
                  <IconButton
                    size='small'
                    className='print-hide'
                    color="success"
                    aria-label="mark comment false"
                    component="label"
                    onClick={() =>
                      showOrHideValidationMessage(notification.ID, false)
                    }
                  >
                    <TaskAltIcon style={{ fontSize: 14 }} />
                  </IconButton>
                ) : (
                  <>
                    {!notification?.defaultValidationMsg && (
                      <EditValidationComment {...props} editData={notification} />
                    )}

                    <IconButton
                      size='small'
                      aria-label="mark comment true"
                      className='print-hide'
                      component="label"
                      sx={{ width: 28, height: 28, padding: 0.5, color: 'text.secondary' }}
                      onClick={() =>
                        showOrHideValidationMessage(notification.ID, true)
                      }
                    >
                      <CancelOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </>
                )
              ) : null}
            >
              {notification?.message}
            </Alert>
          );
        })
      ) : (
        <Alert
          severity="info"
          sx={{
            '& .MuiAlert-icon': {
              fontSize: 15,
              marginTop: '3px',
            },
            fontSize: 11,
            paddingTop: 0,
            paddingBottom: 0
          }}
        >
          No validation messages available.
        </Alert>
      )}
    </div>
  );
}

export default ShowValidationMessages;
